"use client";

import { Menu } from "lucide-react";
import { useLocale, useTranslations } from "next-intl";
import { useState } from "react";
import { Button } from "@/components/ui/button";
import {
  Sheet,
  SheetContent,
  SheetDescription,
  SheetHeader,
  SheetTitle,
  SheetTrigger,
} from "@/components/ui/sheet";
import { Separator } from "@/components/ui/separator";
import { LanguageToggle } from "./language-toggle";
import { NavLinks } from "./nav-links";
import { Link } from "@/i18n/navigation";

export function MobileMenu() {
  const t = useTranslations("nav");
  const locale = useLocale();
  const [open, setOpen] = useState(false);
  const drawerSide = locale === "he" ? "left" : "right";

  return (
    <Sheet open={open} onOpenChange={setOpen}>
      <SheetTrigger
        render={
          <Button
            variant="ghost"
            size="icon"
            className="size-11 md:hidden"
            aria-label={t("menu")}
          />
        }
      >
        <Menu className="size-5" aria-hidden />
      </SheetTrigger>
      <SheetContent side={drawerSide} className="w-[88vw] max-w-sm border-border/40 bg-background/95 backdrop-blur-2xl">
        <SheetHeader className="border-b border-border/40">
          <SheetTitle className="text-start font-sans text-base font-medium tracking-tight">
            Kessem
          </SheetTitle>
          <SheetDescription className="sr-only">
            {t("menu")}
          </SheetDescription>
        </SheetHeader>

        <div className="flex flex-1 flex-col gap-6 px-4 py-4">
          <NavLinks orientation="vertical" onNavigate={() => setOpen(false)} />

          <Separator />

          <div className="flex flex-wrap items-center gap-2">
            <LanguageToggle />
          </div>

          <Link
            href={{ pathname: "/", hash: "contact" }}
            onClick={() => setOpen(false)}
            className="mt-auto inline-flex h-12 items-center justify-center rounded-full bg-primary px-5 text-sm font-medium text-primary-foreground transition-colors hover:bg-primary/90 active:scale-[0.98] focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-ring"
          >
            {t("cta")}
          </Link>
        </div>
      </SheetContent>
    </Sheet>
  );
}
